export default __webpack_public_path__ + "static/media/la2.1.83c2e59c.png";